import PageLay from '@components/layouts/PageLay.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import httpFactory from '@/api/index.js';

import MC from '@utils/request/mc.js';

export default function (Vue) {
  Vue.component(PageLay.name, PageLay);
  Vue.use(ElementUI);
  Vue.use(MC);
  Vue.use(httpFactory, Vue.$mc);
}



// WEBPACK FOOTER //
// ./src/utils/regComp.js